import { Button, Dialog, DialogBody, DialogFooter, Intent, Callout } from '@blueprintjs/core'
import React from 'react'
import { showToast } from '../../../Toast'
import { S } from '../../../utils'

interface Props {
  data: any
  endListingEndpoint: any
  onClose: any
  isOpen: any
  title?: any
  warningMessage?: any
  onSubmitted?: Function
}

interface State {
  loading: any
}

export default class DelistDialog extends React.Component<Props, State> {
  state = {
    loading: false
  }

  endListings = async () => {
    const { data, endListingEndpoint } = this.props
    this.setState({ loading: true })
    try {
      const res = await endListingEndpoint(data)
      this.setState({ loading: false }, () => {
        showToast(`Delisting ${data.length} item${S(data)}...`, Intent.PRIMARY)
        if (this.props.onSubmitted) this.props.onSubmitted()
        this.props.onClose(true, res.data.failed)
      })
    } catch (_error) {
      this.setState({ loading: false })
    }
  }

  render() {
    const { isOpen, onClose, data, title, warningMessage } = this.props
    const { loading } = this.state

    return (
      <Dialog isOpen={isOpen} onClose={onClose} title={title || 'Bulk Delist'}>
        {warningMessage && <Callout intent="warning">{warningMessage}</Callout>}
        <DialogBody>
          Are you sure you want to end {data.length === 1 ? 'this listing?' : `${data.length} listings?`}
        </DialogBody>
        <DialogFooter
          actions={
            <Button loading={loading} intent={Intent.DANGER} onClick={this.endListings}>
              End {data.length} listing{S(data)}
            </Button>
          }
        />
      </Dialog>
    )
  }
}
